import React from 'react';
import Header from "../../components/header/HeaderOne";
import FooterThree from "../../components/footer/FooterThree";
import TemplateListWithSidebar from "../../templates/products/ListWithSidebar";
import SideHeader from "../../components/SideHeader";

const ProductsTwoColumnLeftSidebarPage = () => {


    return (
        <div>
            <Header classes={'position-static'}/>
            <SideHeader mobile={true}/>
            <TemplateListWithSidebar
                listColumnClass={'col-12 col-md-6'}
                sidebarPosition="left"
                showProductsPerPage={10}
            />
            <FooterThree position={'fixed'}/>
        </div>
    );
};

export default ProductsTwoColumnLeftSidebarPage;